import React, {useContext} from 'react'
import { Result } from 'antd';
import { appContext } from "../../AppContext";
//Hooks
import { useTranslation } from 'react-i18next'

export default function ResultPage()
{       
    const [appState] = useContext(appContext);
    const { t } = useTranslation(['result'])
    let code = new URLSearchParams(window.location.search).get("code")

    function getResultByCode() {
        switch(code) {
            case "211":
                return <Result
                    status="success"
                    title={t("result:211.title")}
                    subTitle={t("result:211.description")}
                    extra={<a href={appState.myPrequestUrl}> Log in myPrequest </a>}
                />
            case "511":
                return <Result
                    status="500"
                    title={t("result:511.title")}
                    subTitle={t("result:511.description")}
                />
            case "512":
            case "513":
            case "515":
            case "517":
            case "518":
                return <Result
                    status="500"
                    title={t("result:loginFailed.title")}
                    subTitle={t("result:loginFailed.description")}
                />    
            case "514":
                return <Result
                    status="500"
                    title={t("result:514.title")}
                    subTitle={t("result:514.description")}
                />   
            case "516":
                return <Result
                    status="500"
                    title={t("result:514.title")}
                    subTitle={t("result:514.description")}
                />  
            default:
                return <Result
                    status="500"
                    title={t("result:default.title")}
                    subTitle={t("result:default.description")}
                />
        }
    }

    return (getResultByCode())
}


